import { useQuery } from "@tanstack/react-query";
import { userApi } from "../../api/user";

export const useInfoMine = () => {
  return useQuery({
    queryKey: ["info-mine"],
    queryFn: () => userApi.getInfoMine(),
  });
};
